import { useState } from 'react'
import { useTranslations } from 'next-intl'
import { Icon } from '@alto-avios/alto-ui'
import { Tooltip } from '@reward-platform/lift/components/Tooltip/Tooltip'
import { CarHireBasketItem } from '@reward-platform/order-schemas/basket'
import IconValuePair from '~/components/shared/IconValuePair'
import { ReplaceCarItemCardProps } from '~/components/search-and-results/ReplaceCarItemCard/ReplaceCarItemCard.types'
import { OrderListLineCarHireItem } from '@reward-platform/order-schemas/order/order-list'
import { convertServiceToIcon } from '~/components/search-and-results/CarAdditionalProductCard/utils'
import styles from './CarItemExtrasPopover.module.scss'

type CarItemExtrasPopoverProps = {
  extras: (CarHireBasketItem | ReplaceCarItemCardProps | OrderListLineCarHireItem)['extras']
}

export const CarItemExtrasPopover = ({ extras }: CarItemExtrasPopoverProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const onOpen = () => setIsOpen(true)
  const onClose = () => setIsOpen(false)

  const numberOfExtras: number =
    (extras as Array<{ selectedQuantity?: number }>)?.reduce(
      (acc: number, item) => acc + (item?.selectedQuantity ?? 0),
      0
    ) ?? 0

  const t = useTranslations('pages.details.car_hire.extras_popover')

  return (
    numberOfExtras > 0 && (
      <div className={styles.carExtraWrapper}>
        <Tooltip
          placement="bottom start"
          hasArrow={false}
          trigger="click"
          content={
            <ul className={styles.extrasList}>
              {extras?.map((extraItem) =>
                extraItem?.selectedQuantity && extraItem?.selectedQuantity > 0 ? (
                  <li key={extraItem?.name}>
                    <IconValuePair
                      icon={
                        <Icon
                          {...convertServiceToIcon(extraItem?.serviceSubType)}
                          color="primary"
                        />
                      }
                      value={`${extraItem?.selectedQuantity} x ${extraItem?.name}`}
                    />
                  </li>
                ) : null
              )}
            </ul>
          }
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          triggerContent={
            <div className={styles.triggerContent}>
              <Icon
                aria-hidden="true"
                iconName="circle-check"
                iconPrefix="fas"
                color="accentPrimary"
              />
              <span className={styles.triggerText}>
                {t('additional_car_hire_product_extras_text', {
                  extras: numberOfExtras,
                })}
              </span>
              <Icon
                aria-hidden="true"
                iconName={isOpen ? 'chevron-up' : 'chevron-down'}
                iconSize="0.75x"
              />
            </div>
          }
        />
      </div>
    )
  )
}
